import { useEffect } from "react";
import useVaultIdParam from "@app/Areas/Optimus/State/App/NavigationContext/hooks/useVaultIdParam";
import { useTaskBoardStateContext, useTaskBoardDispatchContext } from "@app/Areas/Optimus/Apps/TaskBoardApp";
import { BOARDS_CLEAR_TASKITEM_UNDER_EDIT } from "../../../state/TaskBoardReducer/TaskBoardReducer";
import useBoardIdParam from "../../_Boards/useBoardIdParam";

function useTaskItemUnderEdit() {
    const vaultId = useVaultIdParam();
    const boardId = useBoardIdParam();

    const boardStateContext = useTaskBoardStateContext();
    const taskItemUnderEdit = boardStateContext.taskItems.selectedToEdit;
    const boardDispatch = useTaskBoardDispatchContext();

    useEffect(() => {
        return function cleanup() {
            boardDispatch({
                type: BOARDS_CLEAR_TASKITEM_UNDER_EDIT
            })
        }
    }, [vaultId])

    if (!taskItemUnderEdit) {
        return null;
    }

    const taskItem = boardStateContext?.taskItems?.byId[taskItemUnderEdit];

    if (
        !taskItem
        || taskItem.parentVaultId !== vaultId
        || taskItem.parentBoardId !== boardId) {
        return null;
    }

    return taskItem;
}

export default useTaskItemUnderEdit;


